import React from 'react';
import { remCss } from 'src/helpers';

const StopRecordIcon = React.memo(({ width = 50, viewBox = '0 0 50 50' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(width)}
    viewBox={viewBox}
  >
    <g id='Group_3939' data-name='Group 3939' transform='translate(-376 -788)'>
      <rect
        id='Rectangle_1389'
        data-name='Rectangle 1389'
        width='50'
        height='50'
        rx='25'
        transform='translate(376 788)'
        fill='#fff'
        opacity='0.2'
      />
      <rect
        id='Rectangle_1390'
        data-name='Rectangle 1390'
        width='22'
        height='22'
        rx='3'
        transform='translate(390 802)'
        fill='#fff'
      />
    </g>
  </svg>
));
StopRecordIcon.displayName = 'StopRecordIcon';

export default StopRecordIcon;
